import React, { useEffect } from "react";
import "./Contact.css";
import { FaEnvelope, FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdmissionsPage,
  getContactPage,
  getProgramsPage,
} from "../../Redux/Slices/AppSlices";
import Loader from "../../Components/Loader/Loader";
import Form from "../../Components/Form/Form";

const Contact = () => {
  const dispatch = useDispatch();
  const { contactPage, loading } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getContactPage());
  }, []);

  if (loading) {
    return <Loader />;
  }

  console.log(contactPage,"contactPage")
  return (
    <div className="admission-page">
      <div className=" landing-pages">
        <div className="Founder-box">
          {/* LEFT CONTENT */}
          <div className="Founder-left">
            <p className="founder-subtitle">{contactPage?.subTitle}</p>

            <h2 className="founder-title">
              {contactPage?.title?.split(" ").slice(0, -1).join(" ")}
              <span> {contactPage?.title?.split(" ").slice(-1).join(" ")}</span>
            </h2>
            <p className="founder-desc">{contactPage?.description}</p>
            <div className="admission-item-btn">
              <div className="contact-item-box">
                <h4 className="founder-subtitle">
                  {contactPage?.admissionTitle}
                </h4>
                <p>
                  <FaEnvelope />
                  {contactPage?.email}
                </p>
                <p>
                  <FaPhoneAlt />
                  {contactPage?.phone}
                </p>
              </div>
            </div>
          </div>

          <div className="Founder-right">
            <div className="image-blob">
              <img src={contactPage?.image?.url} alt="contact" />
            </div>
          </div>
        </div>
        <section className="admission-section contact-box contact-us-page" style={{backgroundImage:`${contactPage?.formImage?.url}`}}>
          <div className="contact-section-box">
            <div className="contact-section-right">
              <div className="contact-section-item">
                <h2>{contactPage?.contactTitle}</h2>
                <div className="contact-item">
                  <FaLocationDot />
                  <div className="contact-item-detail">
                    <h5>Address</h5>
                    <p>{contactPage?.address}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className=" contact-section-left">
              <p className="chooseus-subtitle">
                {contactPage?.enquirySubtitle}
              </p>
              <h2 className="chooseus-title">{contactPage?.enquiryTitle}</h2>
              <Form />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
